<template>
  <div v-if="$hasFeature('track_trace') && $hasPermission('view_tracking_menu')" class="order-wrapper payment-wrapper"
    v-bind:class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="trackMenulist"
        :selectedCategory="selectedCategory"
        :preSearchedParams="searchedParams"
        :searchParameters="rejectsearchParameters"
        :searchText="searchText"
        :enableSearchPopup="true"
        v-on:searchByParameter="searchByParameter"
        />
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content">
        <div class="content"
          v-infinite-scroll="loadData"
          infinite-scroll-disabled="loadCheck"
          infinite-scroll-throttle-delay="400"
          infinite-scroll-distance="10">
          <div>
            <Row :gutter="20" class="grid-header" type="flex">
              <Col v-for="header in rejectListConstant" :key="header.id" :span="header.colSpan">
                {{header.title}}
              </Col>
              <Col :span="7" class="col-push px-20" >
                <span class="card-actionlabel">REASONS</span>
              </Col>
            </Row>
            <div v-if="isLoading" class="paymentloader"></div>
            <div class="status-msg my-sm" v-else-if="!rejectedlist.trips || !rejectedlist.trips.length">
              <span>
                <svgicon name="empty-location" width="251" height="160" :original="true" />
                <p>No Trips available</p>
              </span>
            </div>
            <DetailRow v-else
              v-for="(detail,index) in rejectedlist.trips"
              :key="index"
              :index="index"
              :headers="rejectListConstant"
              @showReasons="showReasons"
              :details="detail">
            </DetailRow>
          </div>
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter
          :selectedFilters="filterConstant"
          :filters="filters"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply"
          @clearDate = "clearDate"/>
      </div>
      <div class="sidenavright" :class="{ isOpen: isOpenUpdate }">
        <ReasonDetails
          v-if="isOpenUpdate && selected"
          :rejectedTrip="selected"
          @close="isOpenUpdate = false" />
      </div>
    </div>
  </div>
  <div v-else class="loading-app page-not-found">
      <h4>Page not found</h4>
      <p>
        Go back to <router-link :to="{ path: '/indents/outbound' }">Indents</router-link>
      </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import { TrackMenu, rejectListConstant, filters, rejectsearchParameters } from '@/constants/trackConstants';
import moment from 'moment';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import DetailRow from '@/components/track/rejectRow';
import ReasonDetails from './RejectionDetails';

export default {
  components: {
    PrimaryFilter,
    SecFilter,
    FilterWrapper,
    DetailRow,
    ReasonDetails,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      isOpenUpdate: false,
      rejectListConstant,
      openSlideleft: true,
      defaultValues: {},
      TrackMenu,
      filterConstant: [],
      filters,
      loadCheck: true,
      dashboardFilter: null,
      rejectsearchParameters,
      searchedParams: {},
      searchText: 'Search',
      selected: null,
    };
  },
  async created() {
    this.$store.commit('track/initialReset');
    this.setDefaults();
    const fromDashboard = this.$route && this.$route.query.fromDashboard;
    if (fromDashboard) {
      this.constructConstantForFilter();
      if (this.$route.query.trans) {
        this.searchedParams.transporter = this.$route.query.trans;
      }
      if (this.$route.query.transporterId) {
        this.searchedParams.transporterId = this.$route.query.transporterId;
      }
    } else {
      this.loadFilters();
      this.constructSearchConstants();
      this.loadSearchFromSession();
    }
    this.dashboardFilter = this.$route && this.$route.query.dashboardFilter;
    this.search();
  },
  computed: {
    ...mapGetters({
      rejectedlist: 'track/rejectedlist',
      isLoading: 'track/isLoading',
      hasEmpty: 'track/hasEmpty',
      filter: 'track/rejectionFilter',
    }),
    selectedCategory() {
      return this.TrackMenu.find(menu => menu.id === 'Rejections');
    },
    filterParams() {
      return this.filterConstant && this.filterConstant.flat();
    },
    trackMenulist() {
      return this.TrackMenu.filter(ele => (ele.permission ? this.$hasPermission(ele.permission) : true));
    },
  },
  methods: {
    showReasons(index) {
      this.selected = this.rejectedlist.trips[index];
      this.isOpenUpdate = true;
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`)
        || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    constructSearchConstants() {
      this.rejectsearchParameters.forEach(param => this.searchedParams[`${param.query}`] = this.defaultValues[`${param.query}`]);
    },
    setDefaults() {
      if (this.$route && this.$route.query.end) {
        this.defaultValues.endDate = this.$route.query.end;
      } else {
        this.defaultValues.endDate = moment().toString();
      }
      if (this.$route && this.$route.query.start) {
        this.defaultValues.startDate = this.$route.query.start;
      } else {
        this.defaultValues.startDate = moment().subtract(15, 'days').toString();
      }
      if (this.$route && this.$route.query) {
        this.defaultValues.transporter = this.$route.query.trans;
      }
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: false,
          },
        ],
      ];
    },
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
    searchApply() {
      const dashboardFilter = this.$route.query.dashboardFilter;
      this.$router.replace({ query: { dashboardFilter } });
      this.search();
    },
    search() {
      this.applyFilters();
      this.openSlideleft = false;
      this.$store.commit('track/setRejectionPage', 1);
      this.loadData();
    },
    searchByParameter(params) {
      const dashboardFilter = this.$route.query.dashboardFilter;
      this.$router.replace({ query: { dashboardFilter } });
      this.searchedParams = params;
      this.$store.commit('track/setRejectionPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    async loadData() {
      try {
        let filter = this.constructFilterPayload();
        if (filter) {
          filter = Object.assign(filter, this.filter);
          // search query params
          const params = {};
          if (this.searchedParams && Object.keys(this.searchedParams).length) {
            Object.assign(params, { ...this.searchedParams });
          }
          filter = Object.assign(filter, params);

          // redirection dashboard filters
          if (this.dashboardFilter) {
            filter = Object.assign(filter, { dashboardFilter: this.dashboardFilter });
          }
          filter = this.serializeObject(filter);
          const result = await this.$store.dispatch('track/rejectionFilter', filter);
          if (result.error) {
            this.$errorMessage({ message: result.error });
          }
          this.loadCheck = this.hasEmpty;
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    serializeObject(data) {
      const result = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach((key) => {
        if (data[key] || data[key] !== '') {
          result[key] = data[key];
        }
      });
      return result;
    },
  },
};
</script>
